import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import ErrorBoundary from "@/components/ErrorBoundary";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import ChatWidget from "@/components/ChatWidget";
import OrderTypeModal from "@/components/OrderTypeModal";
import { AlertTriangle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

function ClosedBanner() {
  const { settings } = useSettings();
  const st = settings?.restaurant_status;
  if (!st || st === "OPEN") return null;
  const map = {
    CLOSED: "METROS is currently closed. You can browse the menu and order when we reopen.",
    BUSY: "We're very busy right now — orders may take a little longer than usual.",
    TEMPORARILY_UNAVAILABLE: "METROS is temporarily unavailable. Please check back soon.",
  };
  const isBusy = st === "BUSY";
  return (
    <div data-testid="status-banner" className={`${isBusy ? "bg-amber-500" : "bg-metros-black"} text-white text-sm text-center py-2 px-4 flex items-center justify-center gap-2`}>
      <AlertTriangle size={15} /> {settings?.status_message || map[st] || "METROS is currently unavailable."}
    </div>
  );
}

export default function Layout() {
  const [orderModal, setOrderModal] = useState(false);
  const openOrderType = () => setOrderModal(true);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <ClosedBanner />
      <Header onOrderOnline={openOrderType} />
      <main className="flex-1">
        <ErrorBoundary>
          <Outlet context={{ openOrderType }} />
        </ErrorBoundary>
      </main>
      <Footer />
      <CartDrawer />
      <ChatWidget />
      <OrderTypeModal open={orderModal} onClose={() => setOrderModal(false)} />
    </div>
  );
}
